const admin2026GlobalSearchBoot = () => {
    if (typeof window === 'undefined' || !window.vAdmin2026GlobalSearch) {
        return {};
    }

    return window.vAdmin2026GlobalSearch;
};

const admin2026GlobalSearchBaseUrl = (input) => {
    const fallback = '/pono-admin/dashboard';

    if (typeof input !== 'string' || !input.trim().length) {
        return fallback;
    }

    try {
        const parsed = new URL(input, window.location.origin);

        return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
        return input;
    }
};

const admin2026ScreenOnboardingPending = () => {
    if (typeof window === 'undefined' || !window.vAdmin2026ScreenOnboarding) {
        return false;
    }

    const boot = window.vAdmin2026ScreenOnboarding;

    return !!(boot && !boot.completed && Array.isArray(boot.steps) && boot.steps.length);
};

const admin2026GlobalSearchExpandedLimit = 500;
const admin2026GlobalSearchRecentScreensInitialLimit = 5;
const admin2026GlobalSearchRecentScreensPageSize = 10;
const admin2026GlobalSearchRecentScreensMaxEntries = 100;
const admin2026GlobalSearchRecentSearchMaxQueryLength = 500;
const admin2026GlobalSearchRecentSearchTypingFragmentWindowMs = 30 * 1000;
const admin2026GlobalSearchClientsGroup = 'clients';
const admin2026GlobalSearchClientsSurface = 'users';
const admin2026GlobalSearchCurrentGroupPrefix = 'current_';
const admin2026GlobalSearchDefaultOrder = 100000;
const admin2026GlobalSearchGroupOrder = {
    clients: 0,
    p81101: 100,
    sales: 10000,
    'programs-offers': 10000,
    content: 20000,
    community: 30000,
    calendar: 40000,
    projects: 50000,
    crm: 60000,
    accounts: 70000,
    advanced: 80000,
    automations: 90000,
    website: 100000,
    pages: 100000,
    'brand-settings': 110000,
};
const admin2026GlobalSearchGroupLabels = {
    clients: 'Clients',
    p81101: 'Nutrigenomix',
    sales: 'Offers & Sales',
    'programs-offers': 'Offers & Sales',
    content: 'Library',
    community: 'Community',
    calendar: 'Calendar',
    projects: 'Projects',
    crm: 'CRM',
    accounts: 'Accounting',
    advanced: 'Reports',
    automations: 'Automations',
    website: 'Website',
    pages: 'Website',
    'brand-settings': 'Settings',
};
const admin2026GlobalSearchSurfaceGroups = {
    users: 'clients',
    user_notes: 'clients',
    user_activity_logs: 'clients',
    messages: 'clients',
    form_entries: 'clients',
    journal_entries: 'clients',
    calendar_bookings: 'clients',
    p81101_barcodes: 'p81101',
    p81101_rd_barcodes: 'p81101',
    p81101_report_queue: 'p81101',
    p81101_lab_batches: 'p81101',
    p81101_report_templates: 'p81101',
    p81101_report_pages: 'p81101',
    products: 'sales',
    in_app_purchases: 'sales',
    reviews: 'sales',
    promo_codes: 'sales',
    client_programs: 'sales',
    sales_overview: 'sales',
    referrals_commission: 'sales',
    referral_clicks: 'sales',
    orders: 'sales',
    invoices: 'sales',
    transactions: 'sales',
    stripe_subscriptions: 'sales',
    paypal_subscriptions: 'sales',
    authorize_net_subscriptions: 'sales',
    subscription_credits: 'sales',
    abandoned_carts: 'sales',
    resources: 'content',
    courses: 'content',
    articles: 'content',
    folders: 'content',
    training_plans: 'content',
    legacy_plans: 'content',
    nutrition: 'content',
    plan_uploads: 'content',
    forms_setup: 'content',
    journal_setup: 'content',
    race_results: 'content',
    progress: 'content',
    competitions: 'content',
    community_channels: 'community',
    community_moderation: 'community',
    calendar_setup: 'calendar',
    projects_task_search: 'projects',
    crm_contacts: 'crm',
    accounting_transactions: 'accounts',
    accounting_customers: 'accounts',
    accounting_vendors: 'accounts',
    accounting_products: 'accounts',
    chart_of_accounts: 'accounts',
    visitor_logs: 'advanced',
    email_logs: 'advanced',
    activity_time_logs: 'advanced',
    groups: 'automations',
    campaigns: 'automations',
    pre_scheduled_campaigns: 'automations',
    app_onboarding: 'automations',
    onboarding_entries: 'automations',
    app_notifications: 'automations',
    app_alerts: 'automations',
    website_pages: 'website',
    redirects: 'website',
    page_backgrounds: 'website',
    website_storage: 'website',
    locations: 'brand-settings',
};
const admin2026GlobalSearchSurfaceOrder = {
    users: 0,
    user_notes: 10,
    user_activity_logs: 20,
    messages: 30,
    form_entries: 40,
    journal_entries: 50,
    calendar_bookings: 60,
    p81101_barcodes: 100,
    p81101_rd_barcodes: 110,
    p81101_report_queue: 120,
    p81101_lab_batches: 130,
    p81101_report_templates: 140,
    p81101_report_pages: 150,
    products: 10000,
    in_app_purchases: 10010,
    reviews: 10020,
    promo_codes: 10030,
    client_programs: 10040,
    sales_overview: 10050,
    referrals_commission: 10060,
    referral_clicks: 10070,
    orders: 10080,
    invoices: 10090,
    transactions: 10100,
    stripe_subscriptions: 10110,
    paypal_subscriptions: 10120,
    authorize_net_subscriptions: 10130,
    subscription_credits: 10140,
    abandoned_carts: 10150,
    resources: 20000,
    courses: 20010,
    articles: 20020,
    folders: 20030,
    training_plans: 20040,
    legacy_plans: 20040,
    nutrition: 20050,
    plan_uploads: 20060,
    forms_setup: 20070,
    journal_setup: 20080,
    race_results: 20110,
    progress: 20120,
    competitions: 20130,
    community_channels: 30000,
    community_moderation: 30010,
    calendar_setup: 40000,
    projects_task_search: 50000,
    crm_contacts: 60000,
    accounting_transactions: 70000,
    accounting_customers: 70010,
    accounting_vendors: 70020,
    accounting_products: 70030,
    chart_of_accounts: 70040,
    visitor_logs: 80000,
    email_logs: 80010,
    activity_time_logs: 80020,
    groups: 90000,
    campaigns: 90010,
    pre_scheduled_campaigns: 90020,
    app_onboarding: 90030,
    onboarding_entries: 90040,
    app_notifications: 90050,
    app_alerts: 90060,
    website_pages: 100000,
    redirects: 100010,
    page_backgrounds: 100020,
    website_storage: 100030,
    locations: 110000,
};

const admin2026GlobalSearchFiniteOrder = (value, fallback) => {
    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : fallback;
};

const admin2026GlobalSearchMappedOrder = (map, key, fallback) => {
    return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : fallback;
};

const admin2026GlobalSearchCompareParts = (leftParts, rightParts) => {
    const length = Math.max(leftParts.length, rightParts.length);

    for (let index = 0; index < length; index += 1) {
        const left = leftParts[index];
        const right = rightParts[index];

        if (left === right) {
            continue;
        }

        if (typeof left === 'number' && typeof right === 'number') {
            return left - right;
        }

        return String(left || '').localeCompare(String(right || ''));
    }

    return 0;
};

const admin2026GlobalSearchRecentPath = (input) => {
    if (typeof input !== 'string' || !input.trim().length) {
        return '';
    }

    try {
        const parsed = new URL(input, window.location.origin);
        const pathname = parsed.pathname || '/';

        return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    } catch (error) {
        const path = input.split('?')[0].split('#')[0].trim();

        if (!path.length) {
            return '';
        }

        const normalized = path.charAt(0) === '/' ? path : `/${path}`;

        return normalized.length > 1 ? normalized.replace(/\/+$/, '') : normalized;
    }
};

const admin2026GlobalSearchRecentClientId = (screen, normalizedUrl = '') => {
    const explicitClientId = screen && Number.isFinite(Number(screen.clientId))
        ? Math.floor(Number(screen.clientId))
        : 0;

    if (explicitClientId > 0) {
        return explicitClientId;
    }

    const url = normalizedUrl || admin2026GlobalSearchRecentPath(screen && screen.url ? screen.url : '');
    const match = url.match(/^\/pono-admin\/workspaces\/clients\/accounts\/(\d+)(?:\/|$)/);

    return match ? Number(match[1]) : 0;
};

const admin2026GlobalSearchRecentScreenIdentity = (screen) => {
    const url = screen && typeof screen.url === 'string' ? screen.url : '';
    const clientId = admin2026GlobalSearchRecentClientId(screen, url);

    return clientId > 0 ? `client:${clientId}` : `screen:${url}`;
};

const admin2026GlobalSearchUniqueRecentScreens = (screens, currentUrl = '') => {
    const seen = new Set();

    return (Array.isArray(screens) ? screens : []).filter((screen) => {
        if (
            !screen
            || typeof screen.url !== 'string'
            || !screen.url.length
            || (currentUrl && screen.url === currentUrl)
        ) {
            return false;
        }

        const identityKey = admin2026GlobalSearchRecentScreenIdentity(screen);

        if (!identityKey.length || seen.has(identityKey)) {
            return false;
        }

        seen.add(identityKey);

        return true;
    });
};

const admin2026GlobalSearchRecentLimit = (value, fallback) => {
    const parsed = Number(value);

    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
};

const admin2026GlobalSearchSurfaceDisplayGroup = (surfaceKey, fallbackGroup) => {
    return admin2026GlobalSearchSurfaceGroups[surfaceKey] || fallbackGroup;
};

const admin2026GlobalSearchSurfaceDisplayOrder = (surfaceKey, fallback) => {
    return admin2026GlobalSearchMappedOrder(admin2026GlobalSearchSurfaceOrder, surfaceKey, fallback);
};

const admin2026GlobalSearchPrepareSurface = (surface, surfaceIndex, fallbackGroup) => {
    const surfaceKey = surface && surface.surface_key ? String(surface.surface_key) : '';
    const displayGroup = surface && typeof surface.display_group === 'string' && surface.display_group.length
        ? surface.display_group
        : admin2026GlobalSearchSurfaceDisplayGroup(surfaceKey, fallbackGroup);
    const displayOrder = admin2026GlobalSearchFiniteOrder(
        surface ? surface.display_order : null,
        admin2026GlobalSearchSurfaceDisplayOrder(surfaceKey, admin2026GlobalSearchDefaultOrder)
    );

    return {
        ...surface,
        display_group: displayGroup,
        display_group_label: surface && typeof surface.display_group_label === 'string' && surface.display_group_label.length
            ? surface.display_group_label
            : (admin2026GlobalSearchGroupLabels[displayGroup] || displayGroup),
        display_order: displayOrder,
        _dashboardGlobalSearchOriginalIndex: surfaceIndex,
    };
};

const admin2026GlobalSearchGroupDisplayOrder = (group) => {
    if (group && group.workspace_group === admin2026GlobalSearchClientsGroup) {
        return admin2026GlobalSearchGroupOrder[admin2026GlobalSearchClientsGroup];
    }

    const surfaces = group && Array.isArray(group.surfaces) ? group.surfaces : [];
    const surfaceGroupOrders = surfaces.map((surface) => {
        const displayGroup = surface && typeof surface.display_group === 'string'
            ? surface.display_group
            : (group && group.workspace_group ? group.workspace_group : '');

        return admin2026GlobalSearchFiniteOrder(
            admin2026GlobalSearchGroupOrder[displayGroup],
            admin2026GlobalSearchFiniteOrder(admin2026GlobalSearchGroupOrder[group.workspace_group], admin2026GlobalSearchDefaultOrder)
        );
    });

    if (surfaceGroupOrders.length) {
        return Math.min(...surfaceGroupOrders);
    }

    return admin2026GlobalSearchFiniteOrder(admin2026GlobalSearchGroupOrder[group.workspace_group], admin2026GlobalSearchDefaultOrder);
};

const admin2026GlobalSearchSurfacePriority = (surface, currentSurfaceKey, workspaceGroup) => {
    const surfaceKey = surface && surface.surface_key ? String(surface.surface_key) : '';

    if (workspaceGroup === admin2026GlobalSearchClientsGroup) {
        if (surfaceKey === admin2026GlobalSearchClientsSurface) {
            return 0;
        }

        if (currentSurfaceKey && surfaceKey === currentSurfaceKey) {
            return 1;
        }

        return 2;
    }

    return currentSurfaceKey && surfaceKey === currentSurfaceKey ? 0 : 1;
};

const admin2026GlobalSearchCompareSurfaces = (left, right, currentSurfaceKey, workspaceGroup) => {
    const leftParts = [
        admin2026GlobalSearchSurfacePriority(left, currentSurfaceKey, workspaceGroup),
        admin2026GlobalSearchFiniteOrder(left ? left.display_order : null, admin2026GlobalSearchDefaultOrder),
        admin2026GlobalSearchFiniteOrder(left ? left._dashboardGlobalSearchOriginalIndex : null, admin2026GlobalSearchDefaultOrder),
        left && left.surface_key ? String(left.surface_key) : '',
    ];
    const rightParts = [
        admin2026GlobalSearchSurfacePriority(right, currentSurfaceKey, workspaceGroup),
        admin2026GlobalSearchFiniteOrder(right ? right.display_order : null, admin2026GlobalSearchDefaultOrder),
        admin2026GlobalSearchFiniteOrder(right ? right._dashboardGlobalSearchOriginalIndex : null, admin2026GlobalSearchDefaultOrder),
        right && right.surface_key ? String(right.surface_key) : '',
    ];

    return admin2026GlobalSearchCompareParts(leftParts, rightParts);
};

const admin2026GlobalSearchRefreshGroup = (group, currentSurfaceKey) => {
    const workspaceGroup = group && group.workspace_group ? String(group.workspace_group) : '';
    const surfaces = Array.isArray(group.surfaces) ? group.surfaces.slice() : [];

    surfaces.sort((left, right) => admin2026GlobalSearchCompareSurfaces(left, right, currentSurfaceKey, workspaceGroup));

    return {
        ...group,
        surfaces,
        display_order: admin2026GlobalSearchGroupDisplayOrder({ ...group, surfaces }),
    };
};

const admin2026GlobalSearchPrepareGroupsForOrdering = (groups) => {
    if (!Array.isArray(groups)) {
        return [];
    }

    return groups.reduce((prepared, group, groupIndex) => {
        if (!group || !group.workspace_group || !Array.isArray(group.surfaces) || !group.surfaces.length) {
            return prepared;
        }

        const workspaceGroup = String(group.workspace_group);
        const surfaces = group.surfaces.reduce((surfaceList, surface, surfaceIndex) => {
            if (!surface || !surface.surface_key) {
                return surfaceList;
            }

            surfaceList.push(admin2026GlobalSearchPrepareSurface(surface, surfaceIndex, workspaceGroup));

            return surfaceList;
        }, []);

        if (!surfaces.length) {
            return prepared;
        }

        prepared.push({
            ...group,
            surfaces,
            _dashboardGlobalSearchOriginalIndex: groupIndex,
        });

        return prepared;
    }, []);
};

const admin2026GlobalSearchGroupContainsSurface = (group, surfaceKey) => {
    return !!(
        group
        && Array.isArray(group.surfaces)
        && group.surfaces.some((surface) => surface && surface.surface_key === surfaceKey)
    );
};

const admin2026GlobalSearchSurfaceBelongsToClients = (groups, surfaceKey) => {
    return groups.some((group) => {
        if (!group || !Array.isArray(group.surfaces)) {
            return false;
        }

        return group.surfaces.some((surface) => {
            return surface
                && surface.surface_key === surfaceKey
                && (
                    group.workspace_group === admin2026GlobalSearchClientsGroup
                    || surface.display_group === admin2026GlobalSearchClientsGroup
                );
        });
    });
};

const admin2026GlobalSearchExtractCurrentSurfaceGroup = (groups, currentSurfaceKey) => {
    let currentSurface = null;
    let sourceGroup = null;

    groups.forEach((group) => {
        const remainingSurfaces = [];

        group.surfaces.forEach((surface) => {
            if (surface && surface.surface_key === currentSurfaceKey) {
                currentSurface = surface;
                sourceGroup = group;

                return;
            }

            remainingSurfaces.push(surface);
        });

        group.surfaces = remainingSurfaces;
    });

    for (let index = groups.length - 1; index >= 0; index -= 1) {
        if (!Array.isArray(groups[index].surfaces) || !groups[index].surfaces.length) {
            groups.splice(index, 1);
        }
    }

    if (!currentSurface || !sourceGroup) {
        return null;
    }

    return {
        workspace_group: `${admin2026GlobalSearchCurrentGroupPrefix}${currentSurfaceKey}`,
        workspace_label: currentSurface.label || sourceGroup.workspace_label || 'Current screen',
        source_workspace_group: sourceGroup.workspace_group || '',
        source_workspace_label: sourceGroup.workspace_label || '',
        display_order: -1,
        is_current_surface_group: true,
        _dashboardGlobalSearchOriginalIndex: sourceGroup._dashboardGlobalSearchOriginalIndex || 0,
        surfaces: [currentSurface],
    };
};

const admin2026GlobalSearchPullClientsGroupWithClientAccounts = (groups) => {
    const groupIndex = groups.findIndex((group) => {
        return group
            && group.workspace_group === admin2026GlobalSearchClientsGroup
            && admin2026GlobalSearchGroupContainsSurface(group, admin2026GlobalSearchClientsSurface);
    });

    if (groupIndex < 0) {
        return null;
    }

    const [group] = groups.splice(groupIndex, 1);

    return group;
};

const admin2026GlobalSearchPullGroupContainingSurface = (groups, surfaceKey) => {
    const groupIndex = groups.findIndex((group) => admin2026GlobalSearchGroupContainsSurface(group, surfaceKey));

    if (groupIndex < 0) {
        return null;
    }

    const [group] = groups.splice(groupIndex, 1);

    return group;
};

const admin2026GlobalSearchCompareGroups = (left, right) => {
    const leftParts = [
        admin2026GlobalSearchFiniteOrder(left ? left.display_order : null, admin2026GlobalSearchDefaultOrder),
        admin2026GlobalSearchFiniteOrder(left ? left._dashboardGlobalSearchOriginalIndex : null, admin2026GlobalSearchDefaultOrder),
        left && left.workspace_group ? String(left.workspace_group) : '',
    ];
    const rightParts = [
        admin2026GlobalSearchFiniteOrder(right ? right.display_order : null, admin2026GlobalSearchDefaultOrder),
        admin2026GlobalSearchFiniteOrder(right ? right._dashboardGlobalSearchOriginalIndex : null, admin2026GlobalSearchDefaultOrder),
        right && right.workspace_group ? String(right.workspace_group) : '',
    ];

    return admin2026GlobalSearchCompareParts(leftParts, rightParts);
};

const admin2026GlobalSearchStripOrderingKeys = (groups) => {
    return groups.map((group) => {
        const cleanedGroup = { ...group };

        delete cleanedGroup._dashboardGlobalSearchOriginalIndex;
        cleanedGroup.surfaces = Array.isArray(cleanedGroup.surfaces)
            ? cleanedGroup.surfaces.map((surface) => {
                const cleanedSurface = { ...surface };
                delete cleanedSurface._dashboardGlobalSearchOriginalIndex;

                return cleanedSurface;
            })
            : [];

        return cleanedGroup;
    });
};

export default {
    data() {
        const boot = admin2026GlobalSearchBoot();
        const deferInitialOpen = !!boot.open && admin2026ScreenOnboardingPending();
        const recentScreens = boot.recentScreens && typeof boot.recentScreens === 'object'
            ? boot.recentScreens
            : {};
        const recentSearches = boot.recentSearches && typeof boot.recentSearches === 'object'
            ? boot.recentSearches
            : {};

        return {
            dashboardGlobalSearchEnabled: !!boot.enabled,
            dashboardGlobalSearchOpen: !!boot.open && !deferInitialOpen,
            dashboardGlobalSearchQuery: !!boot.open && typeof boot.query === 'string' ? boot.query : '',
            dashboardGlobalSearchMinChars: Number.isFinite(Number(boot.minChars)) ? Math.max(2, Number(boot.minChars)) : 2,
            dashboardGlobalSearchDefaultScope: typeof boot.defaultScope === 'string' ? boot.defaultScope : 'everywhere',
            dashboardGlobalSearchScope: typeof boot.scope === 'string' ? boot.scope : 'everywhere',
            dashboardGlobalSearchCurrentSurface: boot.currentSurface && typeof boot.currentSurface === 'object'
                ? boot.currentSurface
                : null,
            dashboardGlobalSearchDashboardUrl: admin2026GlobalSearchBaseUrl(
                typeof boot.dashboardUrl === 'string' && boot.dashboardUrl ? boot.dashboardUrl : '/pono-admin/dashboard'
            ),
            dashboardGlobalSearchRecordEndpoint: typeof boot.recordEndpoint === 'string' ? boot.recordEndpoint : '',
            dashboardGlobalSearchPages: Array.isArray(boot.pages) ? boot.pages : [],
            dashboardGlobalSearchGroups: [],
            dashboardGlobalSearchIgnoreDialogCloseUntil: 0,
            dashboardGlobalSearchWaveStatus: {
                1: 'idle',
                2: 'idle',
                3: 'idle',
            },
            dashboardGlobalSearchSurfaceLoadingAll: {},
            dashboardGlobalSearchRequestId: 0,
            dashboardGlobalSearchAbortController: null,
            dashboardGlobalSearchDebounceId: null,
            dashboardGlobalSearchRecentScreensEnabled: !!recentScreens.enabled,
            dashboardGlobalSearchRecentScreensStorageKey: typeof recentScreens.storageKey === 'string' ? recentScreens.storageKey : '',
            dashboardGlobalSearchCurrentRecentScreen: recentScreens.current && typeof recentScreens.current === 'object'
                ? recentScreens.current
                : null,
            dashboardGlobalSearchRecentScreens: [],
            dashboardGlobalSearchHiddenRoutePrefixes: Array.isArray(recentScreens.hiddenRoutePrefixes)
                ? recentScreens.hiddenRoutePrefixes.filter((prefix) => typeof prefix === 'string' && prefix.length)
                : [],
            dashboardGlobalSearchHiddenPathPrefixes: Array.isArray(recentScreens.hiddenPathPrefixes)
                ? recentScreens.hiddenPathPrefixes.filter((prefix) => typeof prefix === 'string' && prefix.length)
                : [],
            dashboardGlobalSearchHiddenPathPrefixExclusions: Array.isArray(recentScreens.hiddenPathPrefixExclusions)
                ? recentScreens.hiddenPathPrefixExclusions.filter((prefix) => typeof prefix === 'string' && prefix.length)
                : [],
            dashboardGlobalSearchRecentScreensVisibleCount: admin2026GlobalSearchRecentLimit(
                recentScreens.initialLimit,
                admin2026GlobalSearchRecentScreensInitialLimit
            ),
            dashboardGlobalSearchRecentScreensInitialLimit: admin2026GlobalSearchRecentLimit(
                recentScreens.initialLimit,
                admin2026GlobalSearchRecentScreensInitialLimit
            ),
            dashboardGlobalSearchRecentScreensPageSize: admin2026GlobalSearchRecentLimit(
                recentScreens.pageSize,
                admin2026GlobalSearchRecentScreensPageSize
            ),
            dashboardGlobalSearchRecentScreensMaxEntries: admin2026GlobalSearchRecentLimit(
                recentScreens.maxEntries,
                admin2026GlobalSearchRecentScreensMaxEntries
            ),
            dashboardGlobalSearchHistoryTab: 'history',
            dashboardGlobalSearchRecentSearchesEnabled: !!recentSearches.enabled,
            dashboardGlobalSearchRecentSearchesStorageKey: typeof recentSearches.storageKey === 'string' ? recentSearches.storageKey : '',
            dashboardGlobalSearchRecentSearches: [],
            dashboardGlobalSearchRecentSearchDraftQuery: '',
            dashboardGlobalSearchRecentSearchesVisibleCount: admin2026GlobalSearchRecentLimit(
                recentSearches.initialLimit,
                admin2026GlobalSearchRecentScreensInitialLimit
            ),
            dashboardGlobalSearchRecentSearchesInitialLimit: admin2026GlobalSearchRecentLimit(
                recentSearches.initialLimit,
                admin2026GlobalSearchRecentScreensInitialLimit
            ),
            dashboardGlobalSearchRecentSearchesPageSize: admin2026GlobalSearchRecentLimit(
                recentSearches.pageSize,
                admin2026GlobalSearchRecentScreensPageSize
            ),
            dashboardGlobalSearchRecentSearchesMaxEntries: admin2026GlobalSearchRecentLimit(
                recentSearches.maxEntries,
                admin2026GlobalSearchRecentScreensMaxEntries
            ),
        };
    },
    computed: {
        dashboardGlobalSearchCurrentScopeAvailable() {
            return !!(
                this.dashboardGlobalSearchCurrentSurface
                && typeof this.dashboardGlobalSearchCurrentSurface.surfaceKey === 'string'
                && this.dashboardGlobalSearchCurrentSurface.surfaceKey.length
            );
        },
        dashboardGlobalSearchActiveWave() {
            if (
                this.dashboardGlobalSearchScope === 'current'
                && this.dashboardGlobalSearchCurrentScopeAvailable
                && Number.isFinite(Number(this.dashboardGlobalSearchCurrentSurface.wave))
            ) {
                return Math.max(1, Math.min(3, Number(this.dashboardGlobalSearchCurrentSurface.wave)));
            }

            return 1;
        },
        dashboardGlobalSearchTitle() {
            return 'Search';
        },
        dashboardGlobalSearchPlaceholder() {
            if (this.dashboardGlobalSearchScope === 'current' && this.dashboardGlobalSearchCurrentScopeAvailable) {
                return `Search ${this.dashboardGlobalSearchCurrentSurface.displayLabel || this.dashboardGlobalSearchCurrentSurface.label || 'current screen'}`;
            }

            return 'Search people, emails, URLs, and titles';
        },
        dashboardGlobalSearchShowsPages() {
            return false;
        },
        dashboardGlobalSearchFilteredPages() {
            if (!Array.isArray(this.dashboardGlobalSearchPages)) {
                return [];
            }

            const query = (this.dashboardGlobalSearchQuery || '').trim().toLowerCase();

            if (!query.length) {
                return this.dashboardGlobalSearchPages;
            }

            return this.dashboardGlobalSearchPages.filter((page) => {
                return [
                    page.label,
                    page.description,
                    page.destination_url,
                    page.key,
                ].join(' ').toLowerCase().includes(query);
            });
        },
        dashboardGlobalSearchHasRecordResults() {
            return this.dashboardGlobalSearchGroups.some((group) => {
                return Array.isArray(group.surfaces) && group.surfaces.length > 0;
            });
        },
        dashboardGlobalSearchHasClientsGroup() {
            return this.dashboardGlobalSearchGroups.some((group) => {
                return group
                    && group.workspace_group === admin2026GlobalSearchClientsGroup
                    && Array.isArray(group.surfaces)
                    && group.surfaces.length > 0;
            });
        },
        dashboardGlobalSearchClientsLoadingPlaceholder() {
            return this.dashboardGlobalSearchScope !== 'current'
                && this.dashboardGlobalSearchQuery.trim().length >= this.dashboardGlobalSearchMinChars
                && !this.dashboardGlobalSearchHasClientsGroup
                && this.dashboardGlobalSearchWaveStatus[2] === 'loading';
        },
        dashboardGlobalSearchLoadingMore() {
            if (this.dashboardGlobalSearchScope === 'current') {
                return false;
            }

            return this.dashboardGlobalSearchHasRecordResults
                && (
                    this.dashboardGlobalSearchWaveStatus[2] === 'loading'
                    || this.dashboardGlobalSearchWaveStatus[3] === 'loading'
                );
        },
        dashboardGlobalSearchAllWavesLoaded() {
            if (this.dashboardGlobalSearchScope === 'current') {
                return this.dashboardGlobalSearchWaveStatus[this.dashboardGlobalSearchActiveWave] === 'success';
            }

            return [1, 2, 3].every((wave) => this.dashboardGlobalSearchWaveStatus[wave] === 'success');
        },
        dashboardGlobalSearchBlockingErrorWave() {
            if (this.dashboardGlobalSearchScope === 'current') {
                return this.dashboardGlobalSearchWaveStatus[this.dashboardGlobalSearchActiveWave] === 'error'
                    ? this.dashboardGlobalSearchActiveWave
                    : 0;
            }

            if (this.dashboardGlobalSearchWaveStatus[1] === 'error' && !this.dashboardGlobalSearchHasRecordResults) {
                return 1;
            }

            return 0;
        },
        dashboardGlobalSearchInlineErrorWave() {
            if (this.dashboardGlobalSearchScope === 'current') {
                return 0;
            }

            if (this.dashboardGlobalSearchWaveStatus[2] === 'error') {
                return 2;
            }

            if (this.dashboardGlobalSearchWaveStatus[3] === 'error') {
                return 3;
            }

            return 0;
        },
        dashboardGlobalSearchCombinedEmptyState() {
            return this.dashboardGlobalSearchOpen
                && this.dashboardGlobalSearchQuery.trim().length >= this.dashboardGlobalSearchMinChars
                && this.dashboardGlobalSearchAllWavesLoaded
                && !this.dashboardGlobalSearchHasRecordResults
                && !this.dashboardGlobalSearchShowsPages;
        },
        dashboardGlobalSearchRecordsEmptyState() {
            return this.dashboardGlobalSearchOpen
                && this.dashboardGlobalSearchScope !== 'current'
                && this.dashboardGlobalSearchQuery.trim().length >= this.dashboardGlobalSearchMinChars
                && this.dashboardGlobalSearchAllWavesLoaded
                && !this.dashboardGlobalSearchHasRecordResults
                && this.dashboardGlobalSearchShowsPages;
        },
        dashboardGlobalSearchCurrentRecentScreenUrl() {
            return this.normalizeDashboardGlobalSearchRecentScreenUrl(
                this.dashboardGlobalSearchCurrentRecentScreen
                    ? this.dashboardGlobalSearchCurrentRecentScreen.url
                    : ''
            );
        },
        dashboardGlobalSearchRecentHistoryItems() {
            return admin2026GlobalSearchUniqueRecentScreens(
                this.dashboardGlobalSearchRecentScreens,
                this.dashboardGlobalSearchCurrentRecentScreenUrl
            ).filter((screen) => {
                const routeName = screen && typeof screen.routeName === 'string'
                    ? screen.routeName
                    : '';
                const hidden = this.dashboardGlobalSearchHiddenRoutePrefixes.some((prefix) => {
                    return routeName.indexOf(prefix) === 0;
                });
                const screenUrl = this.normalizeDashboardGlobalSearchRecentScreenUrl(screen && screen.url ? screen.url : '');
                const excludedPath = this.dashboardGlobalSearchHiddenPathPrefixExclusions.some((prefix) => {
                    return screenUrl === prefix || screenUrl.indexOf(prefix + '/') === 0;
                });
                const hiddenPath = !excludedPath && this.dashboardGlobalSearchHiddenPathPrefixes.some((prefix) => {
                    return screenUrl === prefix || screenUrl.indexOf(prefix + '/') === 0;
                });

                return !hidden && !hiddenPath;
            });
        },
        dashboardGlobalSearchVisibleRecentScreens() {
            return this.dashboardGlobalSearchRecentHistoryItems.slice(0, this.dashboardGlobalSearchRecentScreensVisibleCount);
        },
        dashboardGlobalSearchCanShowMoreRecentScreens() {
            return this.dashboardGlobalSearchRecentHistoryItems.length > this.dashboardGlobalSearchVisibleRecentScreens.length;
        },
        dashboardGlobalSearchHasRecentActivity() {
            return this.dashboardGlobalSearchRecentHistoryItems.length > 0
                || this.dashboardGlobalSearchRecentSearches.length > 0;
        },
        dashboardGlobalSearchVisibleRecentSearches() {
            return this.dashboardGlobalSearchRecentSearches.slice(0, this.dashboardGlobalSearchRecentSearchesVisibleCount);
        },
        dashboardGlobalSearchCanShowMoreRecentSearches() {
            return this.dashboardGlobalSearchRecentSearches.length > this.dashboardGlobalSearchVisibleRecentSearches.length;
        },
    },
    methods: {
        normalizeDashboardGlobalSearchRecentScreenUrl(url = '') {
            return admin2026GlobalSearchRecentPath(url);
        },
        normalizeDashboardGlobalSearchRecentScreenTitle(title = '', url = '') {
            const normalizedTitle = typeof title === 'string' ? title.trim() : '';

            if (normalizedTitle.length) {
                return normalizedTitle;
            }

            return this.normalizeDashboardGlobalSearchRecentScreenUrl(url) || 'Admin screen';
        },
        normalizeDashboardGlobalSearchRecentScreen(screen = null) {
            if (!screen || typeof screen !== 'object') {
                return null;
            }

            const url = this.normalizeDashboardGlobalSearchRecentScreenUrl(screen.url || '');

            if (!url.length || !url.startsWith('/pono-admin')) {
                return null;
            }

            return {
                title: this.normalizeDashboardGlobalSearchRecentScreenTitle(screen.title || '', url),
                url: url,
                routeName: typeof screen.routeName === 'string' ? screen.routeName : '',
                clientId: admin2026GlobalSearchRecentClientId(screen, url),
                visitedAt: Number.isFinite(Number(screen.visitedAt)) ? Number(screen.visitedAt) : Date.now(),
            };
        },
        loadDashboardGlobalSearchRecentScreens() {
            if (
                !this.dashboardGlobalSearchRecentScreensEnabled
                || !this.dashboardGlobalSearchRecentScreensStorageKey
                || typeof window === 'undefined'
            ) {
                this.dashboardGlobalSearchRecentScreens = [];

                return [];
            }

            try {
                const storage = window.localStorage;

                if (!storage) {
                    this.dashboardGlobalSearchRecentScreens = [];

                    return [];
                }

                const raw = storage.getItem(this.dashboardGlobalSearchRecentScreensStorageKey);
                const parsed = raw ? JSON.parse(raw) : [];
                const seen = {};
                const screens = [];

                if (Array.isArray(parsed)) {
                    parsed.forEach((screen) => {
                        const normalized = this.normalizeDashboardGlobalSearchRecentScreen(screen);

                        if (!normalized || seen[normalized.url]) {
                            return;
                        }

                        seen[normalized.url] = true;
                        screens.push(normalized);
                    });
                }

                this.dashboardGlobalSearchRecentScreens = screens.slice(0, this.dashboardGlobalSearchRecentScreensMaxEntries);

                return this.dashboardGlobalSearchRecentScreens;
            } catch (error) {
                this.dashboardGlobalSearchRecentScreens = [];

                return [];
            }
        },
        persistDashboardGlobalSearchRecentScreens(screens = []) {
            if (
                !this.dashboardGlobalSearchRecentScreensEnabled
                || !this.dashboardGlobalSearchRecentScreensStorageKey
                || typeof window === 'undefined'
            ) {
                return;
            }

            try {
                const storage = window.localStorage;

                if (!storage) {
                    return;
                }

                storage.setItem(
                    this.dashboardGlobalSearchRecentScreensStorageKey,
                    JSON.stringify(screens.slice(0, this.dashboardGlobalSearchRecentScreensMaxEntries))
                );
            } catch (error) {}
        },
        recordDashboardGlobalSearchCurrentScreen() {
            const current = this.normalizeDashboardGlobalSearchRecentScreen({
                ...(this.dashboardGlobalSearchCurrentRecentScreen || {}),
                visitedAt: Date.now(),
            });

            if (!current) {
                this.loadDashboardGlobalSearchRecentScreens();

                return;
            }

            const screens = this.loadDashboardGlobalSearchRecentScreens()
                .filter((screen) => screen && screen.url !== current.url);
            const nextScreens = [current].concat(screens).slice(0, this.dashboardGlobalSearchRecentScreensMaxEntries);

            this.dashboardGlobalSearchRecentScreens = nextScreens;
            this.dashboardGlobalSearchRecentScreensVisibleCount = this.dashboardGlobalSearchRecentScreensInitialLimit;
            this.persistDashboardGlobalSearchRecentScreens(nextScreens);
        },
        showMoreDashboardGlobalSearchRecentScreens() {
            this.dashboardGlobalSearchRecentScreensVisibleCount += this.dashboardGlobalSearchRecentScreensPageSize;
        },
        normalizeDashboardGlobalSearchRecentSearch(search = null) {
            const rawQuery = typeof search === 'string'
                ? search
                : (search && typeof search.query === 'string' ? search.query : '');
            const query = rawQuery.trim();

            if (
                query.length < this.dashboardGlobalSearchMinChars
                || query.length > admin2026GlobalSearchRecentSearchMaxQueryLength
            ) {
                return null;
            }

            return {
                query: query,
                searchedAt: Number.isFinite(Number(search && search.searchedAt))
                    ? Number(search.searchedAt)
                    : Date.now(),
            };
        },
        dashboardGlobalSearchRecentSearchIsTypingFragment(search = null, completeSearch = null) {
            const fragment = this.normalizeDashboardGlobalSearchRecentSearch(search);
            const complete = this.normalizeDashboardGlobalSearchRecentSearch(completeSearch);

            if (!fragment || !complete) {
                return false;
            }

            const fragmentQuery = fragment.query.toLowerCase();
            const completeQuery = complete.query.toLowerCase();
            const elapsed = complete.searchedAt - fragment.searchedAt;

            return fragmentQuery.length < completeQuery.length
                && completeQuery.startsWith(fragmentQuery)
                && elapsed >= 0
                && elapsed <= admin2026GlobalSearchRecentSearchTypingFragmentWindowMs;
        },
        loadDashboardGlobalSearchRecentSearches() {
            if (
                !this.dashboardGlobalSearchRecentSearchesEnabled
                || !this.dashboardGlobalSearchRecentSearchesStorageKey
                || typeof window === 'undefined'
            ) {
                this.dashboardGlobalSearchRecentSearches = [];

                return [];
            }

            try {
                const storage = window.localStorage;

                if (!storage) {
                    this.dashboardGlobalSearchRecentSearches = [];

                    return [];
                }

                const raw = storage.getItem(this.dashboardGlobalSearchRecentSearchesStorageKey);
                const parsed = raw ? JSON.parse(raw) : [];
                const seen = new Set();
                const searches = [];

                if (Array.isArray(parsed)) {
                    parsed.forEach((search) => {
                        const normalized = this.normalizeDashboardGlobalSearchRecentSearch(search);
                        const key = normalized ? normalized.query.toLowerCase() : '';
                        const isTypingFragment = normalized && searches.some((completeSearch) => {
                            return this.dashboardGlobalSearchRecentSearchIsTypingFragment(normalized, completeSearch);
                        });

                        if (!normalized || seen.has(key) || isTypingFragment) {
                            return;
                        }

                        seen.add(key);
                        searches.push(normalized);
                    });
                }

                this.dashboardGlobalSearchRecentSearches = searches.slice(0, this.dashboardGlobalSearchRecentSearchesMaxEntries);

                if (JSON.stringify(parsed) !== JSON.stringify(this.dashboardGlobalSearchRecentSearches)) {
                    this.persistDashboardGlobalSearchRecentSearches(this.dashboardGlobalSearchRecentSearches);
                }

                return this.dashboardGlobalSearchRecentSearches;
            } catch (error) {
                this.dashboardGlobalSearchRecentSearches = [];

                return [];
            }
        },
        persistDashboardGlobalSearchRecentSearches(searches = []) {
            if (
                !this.dashboardGlobalSearchRecentSearchesEnabled
                || !this.dashboardGlobalSearchRecentSearchesStorageKey
                || typeof window === 'undefined'
            ) {
                return;
            }

            try {
                const storage = window.localStorage;

                if (!storage) {
                    return;
                }

                storage.setItem(
                    this.dashboardGlobalSearchRecentSearchesStorageKey,
                    JSON.stringify(searches.slice(0, this.dashboardGlobalSearchRecentSearchesMaxEntries))
                );
            } catch (error) {}
        },
        recordDashboardGlobalSearchRecentSearch(query = '') {
            if (!this.dashboardGlobalSearchRecentSearchesEnabled) {
                return;
            }

            const current = this.normalizeDashboardGlobalSearchRecentSearch({
                query: query,
                searchedAt: Date.now(),
            });

            if (!current) {
                return;
            }

            const normalizedQuery = current.query.toLowerCase();
            const draftQuery = typeof this.dashboardGlobalSearchRecentSearchDraftQuery === 'string'
                ? this.dashboardGlobalSearchRecentSearchDraftQuery.trim().toLowerCase()
                : '';
            const searches = this.loadDashboardGlobalSearchRecentSearches()
                .filter((search) => {
                    if (!search || typeof search.query !== 'string') {
                        return false;
                    }

                    const searchQuery = search.query.toLowerCase();

                    return searchQuery !== normalizedQuery
                        && (!draftQuery || searchQuery !== draftQuery)
                        && !this.dashboardGlobalSearchRecentSearchIsTypingFragment(search, current);
                });
            const nextSearches = [current].concat(searches).slice(0, this.dashboardGlobalSearchRecentSearchesMaxEntries);

            this.dashboardGlobalSearchRecentSearchDraftQuery = current.query;
            this.dashboardGlobalSearchRecentSearches = nextSearches;
            this.dashboardGlobalSearchRecentSearchesVisibleCount = this.dashboardGlobalSearchRecentSearchesInitialLimit;
            this.persistDashboardGlobalSearchRecentSearches(nextSearches);
        },
        showMoreDashboardGlobalSearchRecentSearches() {
            this.dashboardGlobalSearchRecentSearchesVisibleCount += this.dashboardGlobalSearchRecentSearchesPageSize;
        },
        runDashboardGlobalSearchRecentSearch(search = null) {
            const recentSearch = this.normalizeDashboardGlobalSearchRecentSearch(search);

            if (!recentSearch || !this.dashboardGlobalSearchOpen) {
                return;
            }

            this.dashboardGlobalSearchQuery = recentSearch.query;
            this.dashboardGlobalSearchRecentSearchDraftQuery = '';
            this.clearDashboardGlobalSearchDebounce();
            this.abortDashboardGlobalSearchRequest();
            this.resetDashboardGlobalSearchRecords();
            this.syncDashboardGlobalSearchUrl();
            this.startDashboardGlobalSearchFromWave(this.dashboardGlobalSearchActiveWave, true);
            this.focusDashboardGlobalSearchInput();
        },
        admin2026GlobalSearchOnboardingActive() {
            return !!(
                this.dashboardOnboardingDrawerActive
                || this.admin2026OnboardingActive
                || this.admin2026OnboardingCompleting
            );
        },
        normalizeDashboardGlobalSearchScope(scope = null) {
            const requestedScope = typeof scope === 'string' ? scope : this.dashboardGlobalSearchScope;

            if (requestedScope === 'current' && this.dashboardGlobalSearchCurrentScopeAvailable) {
                return 'current';
            }

            return 'everywhere';
        },
        dashboardGlobalSearchSurfaceIsCurrent(surface = null) {
            const surfaceKey = surface && typeof surface.surface_key === 'string' ? surface.surface_key : '';

            return !!(
                surfaceKey.length
                && this.dashboardGlobalSearchCurrentScopeAvailable
                && this.dashboardGlobalSearchCurrentSurface.surfaceKey === surfaceKey
            );
        },
        armDashboardGlobalSearchDialogCloseIgnoreWindow() {
            this.dashboardGlobalSearchIgnoreDialogCloseUntil = Date.now() + 500;
        },
        handleDashboardGlobalSearchDialogClose(payload = null) {
            // Ignore generic Headless UI close requests for this drawer.
            // Explicit Escape, backdrop, and button handlers own closing.
        },
        dashboardGlobalSearchBackdropPointerIsPrimary(event) {
            return !!(
                event
                && event.target === event.currentTarget
                && (typeof event.button !== 'number' || event.button === 0)
                && (typeof event.isPrimary !== 'boolean' || event.isPrimary === true)
            );
        },
        handleDashboardGlobalSearchBackdropPointerDown(event) {
            if (!this.dashboardGlobalSearchBackdropPointerIsPrimary(event)) {
                this.resetDashboardGlobalSearchBackdropPointer();
                return;
            }

            this._dashboardGlobalSearchBackdropPointer = {
                pointerId: typeof event.pointerId === 'number' ? event.pointerId : null,
                clientX: Number.isFinite(Number(event.clientX)) ? Number(event.clientX) : 0,
                clientY: Number.isFinite(Number(event.clientY)) ? Number(event.clientY) : 0,
                startedAt: Number.isFinite(Number(event.timeStamp)) ? Number(event.timeStamp) : Date.now(),
            };
        },
        handleDashboardGlobalSearchBackdropPointerUp(event) {
            const pointer = this._dashboardGlobalSearchBackdropPointer || null;

            this.resetDashboardGlobalSearchBackdropPointer();

            if (!pointer || !this.dashboardGlobalSearchOpen || !this.dashboardGlobalSearchBackdropPointerIsPrimary(event)) {
                return;
            }

            if (pointer.pointerId !== null && typeof event.pointerId === 'number' && event.pointerId !== pointer.pointerId) {
                return;
            }

            const clientX = Number.isFinite(Number(event.clientX)) ? Number(event.clientX) : 0;
            const clientY = Number.isFinite(Number(event.clientY)) ? Number(event.clientY) : 0;
            const endedAt = Number.isFinite(Number(event.timeStamp)) ? Number(event.timeStamp) : Date.now();

            if (Math.abs(clientX - pointer.clientX) > 6 || Math.abs(clientY - pointer.clientY) > 6 || Math.abs(endedAt - pointer.startedAt) > 750) {
                return;
            }

            this.closeDashboardGlobalSearch(true, 'backdrop');
        },
        resetDashboardGlobalSearchBackdropPointer() {
            this._dashboardGlobalSearchBackdropPointer = null;
        },
        openDashboardGlobalSearch(focusInput = true) {
            if (!this.dashboardGlobalSearchEnabled) {
                return;
            }

            if (
                typeof this.admin2026RunAfterScreenOnboarding === 'function'
                && this.admin2026RunAfterScreenOnboarding(() => {
                    this.openDashboardGlobalSearch(focusInput);
                })
            ) {
                return;
            }

            if (this.admin2026GlobalSearchOnboardingActive()) {
                return;
            }

            setTimeout(() => {
                this.dashboardGlobalSearchScope = this.normalizeDashboardGlobalSearchScope(this.dashboardGlobalSearchDefaultScope);
                this.armDashboardGlobalSearchDialogCloseIgnoreWindow();
                this.dashboardGlobalSearchOpen = true;
                this.syncDashboardGlobalSearchUrl();

                if (focusInput) {
                    this.focusDashboardGlobalSearchInput();
                }

                if (
                    this.dashboardGlobalSearchQuery.trim().length >= this.dashboardGlobalSearchMinChars
                    && !this.dashboardGlobalSearchHasRecordResults
                    && this.dashboardGlobalSearchWaveStatus[this.dashboardGlobalSearchActiveWave] === 'idle'
                ) {
                    this.startDashboardGlobalSearchFromWave(this.dashboardGlobalSearchActiveWave, true);
                }
            }, 0);
        },
        closeDashboardGlobalSearch(syncUrl = true, reason = 'manual') {
            this.clearDashboardGlobalSearchDebounce();
            this.abortDashboardGlobalSearchRequest();
            this.dashboardGlobalSearchOpen = false;
            this.resetDashboardGlobalSearchBackdropPointer();
            this.dashboardGlobalSearchQuery = '';
            this.dashboardGlobalSearchRecentSearchDraftQuery = '';
            this.dashboardGlobalSearchScope = this.normalizeDashboardGlobalSearchScope(this.dashboardGlobalSearchDefaultScope);
            this.dashboardGlobalSearchIgnoreDialogCloseUntil = 0;
            this.resetDashboardGlobalSearchRecords();

            if (syncUrl) {
                this.syncDashboardGlobalSearchUrl(this.dashboardGlobalSearchDashboardUrl);
            }
        },
        clearDashboardGlobalSearch() {
            this.dashboardGlobalSearchQuery = '';
            this.dashboardGlobalSearchRecentSearchDraftQuery = '';
            this.clearDashboardGlobalSearchDebounce();
            this.abortDashboardGlobalSearchRequest();
            this.resetDashboardGlobalSearchRecords();
            this.syncDashboardGlobalSearchUrl();
            this.focusDashboardGlobalSearchInput();
        },
        handleDashboardGlobalSearchInput() {
            this.clearDashboardGlobalSearchDebounce();
            this.abortDashboardGlobalSearchRequest();
            this.resetDashboardGlobalSearchRecords();

            if (this.dashboardGlobalSearchQuery.trim().length < this.dashboardGlobalSearchMinChars) {
                this.dashboardGlobalSearchRecentSearchDraftQuery = '';
            }

            this.dashboardGlobalSearchDebounceId = setTimeout(() => {
                this.applyDashboardGlobalSearchQuery();
            }, 250);
        },
        handleDashboardGlobalSearchScopeChange(scope = null) {
            this.dashboardGlobalSearchScope = this.normalizeDashboardGlobalSearchScope(scope);
            this.clearDashboardGlobalSearchDebounce();
            this.abortDashboardGlobalSearchRequest();
            this.resetDashboardGlobalSearchRecords();
            this.syncDashboardGlobalSearchUrl();
            this.focusDashboardGlobalSearchInput();

            if (this.dashboardGlobalSearchQuery.trim().length >= this.dashboardGlobalSearchMinChars) {
                this.startDashboardGlobalSearchFromWave(this.dashboardGlobalSearchActiveWave, true);
            }
        },
        applyDashboardGlobalSearchQuery() {
            if (!this.dashboardGlobalSearchOpen) {
                return;
            }

            this.syncDashboardGlobalSearchUrl();

            if (
                this.dashboardGlobalSearchQuery.trim().length < this.dashboardGlobalSearchMinChars
                || !this.dashboardGlobalSearchRecordEndpoint
                || (this.dashboardGlobalSearchScope === 'current' && !this.dashboardGlobalSearchCurrentScopeAvailable)
            ) {
                return;
            }

            this.startDashboardGlobalSearchFromWave(this.dashboardGlobalSearchActiveWave, true);
        },
        retryDashboardGlobalSearchWave(wave) {
            if (!wave) {
                return;
            }

            this.clearDashboardGlobalSearchDebounce();
            this.syncDashboardGlobalSearchUrl();
            this.startDashboardGlobalSearchFromWave(
                this.dashboardGlobalSearchScope === 'current' ? this.dashboardGlobalSearchActiveWave : wave,
                wave === 1 || this.dashboardGlobalSearchScope === 'current'
            );
        },
        startDashboardGlobalSearchFromWave(wave, clearExisting = false) {
            const query = this.dashboardGlobalSearchQuery.trim();
            const scope = this.normalizeDashboardGlobalSearchScope();
            const activeWave = scope === 'current' ? this.dashboardGlobalSearchActiveWave : wave;

            if (
                !this.dashboardGlobalSearchOpen
                || query.length < this.dashboardGlobalSearchMinChars
                || !this.dashboardGlobalSearchRecordEndpoint
                || (scope === 'current' && !this.dashboardGlobalSearchCurrentScopeAvailable)
            ) {
                return;
            }

            this.recordDashboardGlobalSearchRecentSearch(query);
            this.abortDashboardGlobalSearchRequest();
            this.dashboardGlobalSearchRequestId += 1;

            if (clearExisting || scope === 'current') {
                this.resetDashboardGlobalSearchRecords();
            } else {
                for (let waveToReset = activeWave; waveToReset <= 3; waveToReset += 1) {
                    this.dashboardGlobalSearchWaveStatus[waveToReset] = 'idle';
                }
            }

            this.loadDashboardGlobalSearchWave(activeWave, this.dashboardGlobalSearchRequestId, query);
        },
        loadDashboardGlobalSearchWave(wave, requestId, query) {
            if (!this.dashboardGlobalSearchRecordEndpoint || requestId !== this.dashboardGlobalSearchRequestId) {
                return;
            }

            this.dashboardGlobalSearchWaveStatus[wave] = 'loading';
            this.dashboardGlobalSearchAbortController = typeof AbortController !== 'undefined'
                ? new AbortController()
                : null;

            this.axios.get(this.dashboardGlobalSearchRecordEndpoint, {
                params: {
                    search: query,
                    wave: wave,
                    limit_per_surface: 5,
                    scope: this.normalizeDashboardGlobalSearchScope(),
                    surface_key: this.dashboardGlobalSearchCurrentScopeAvailable
                        ? this.dashboardGlobalSearchCurrentSurface.surfaceKey
                        : null,
                },
                signal: this.dashboardGlobalSearchAbortController ? this.dashboardGlobalSearchAbortController.signal : undefined,
            }).then((response) => {
                if (requestId !== this.dashboardGlobalSearchRequestId || !this.dashboardGlobalSearchOpen) {
                    return;
                }

                const payload = response && response.data ? response.data : {};

                this.mergeDashboardGlobalSearchGroups(Array.isArray(payload.groups) ? payload.groups : []);
                this.dashboardGlobalSearchWaveStatus[wave] = 'success';
                this.dashboardGlobalSearchAbortController = null;

                if (this.dashboardGlobalSearchScope !== 'current' && wave < 3) {
                    this.loadDashboardGlobalSearchWave(wave + 1, requestId, query);
                }
            }).catch((error) => {
                const cancelled = this.isDashboardGlobalSearchCancellation(error);

                if (cancelled || requestId !== this.dashboardGlobalSearchRequestId) {
                    return;
                }

                this.dashboardGlobalSearchWaveStatus[wave] = 'error';
                this.dashboardGlobalSearchAbortController = null;
            });
        },
        dashboardGlobalSearchSurfaceShownCount(surface = null) {
            return surface && Array.isArray(surface.results) ? surface.results.length : 0;
        },
        dashboardGlobalSearchSurfaceResultCount(surface = null) {
            const count = surface ? Number(surface.result_count) : 0;

            return Number.isFinite(count) ? Math.max(0, count) : 0;
        },
        dashboardGlobalSearchSurfaceResultCountLabel(surface = null) {
            const total = this.dashboardGlobalSearchSurfaceResultCount(surface);

            if (surface && surface.result_count_is_lower_bound) {
                return `${Math.max(0, total - 1)}+ results`;
            }

            return `${total} result${total === 1 ? '' : 's'}`;
        },
        dashboardGlobalSearchSurfaceCanExpand(surface = null) {
            if (!surface || surface.presentation === 'list_only' || !surface.surface_key) {
                return false;
            }

            return this.dashboardGlobalSearchSurfaceExpandLimit(surface) > this.dashboardGlobalSearchSurfaceShownCount(surface);
        },
        dashboardGlobalSearchSurfaceExpandLimit(surface = null) {
            if (surface && surface.result_count_is_lower_bound) {
                return admin2026GlobalSearchExpandedLimit;
            }

            return Math.min(this.dashboardGlobalSearchSurfaceResultCount(surface), admin2026GlobalSearchExpandedLimit);
        },
        dashboardGlobalSearchSurfaceExpandLabel(surface = null) {
            const total = this.dashboardGlobalSearchSurfaceResultCount(surface);
            const limit = this.dashboardGlobalSearchSurfaceExpandLimit(surface);

            if (surface && surface.result_count_is_lower_bound) {
                return 'Show more results';
            }

            if (total > limit) {
                return `Show first ${limit} of ${total} results`;
            }

            return `Show all ${total} result${total === 1 ? '' : 's'}`;
        },
        dashboardGlobalSearchSurfaceIsLoadingAll(surface = null) {
            const surfaceKey = surface && surface.surface_key ? surface.surface_key : '';

            return !!(surfaceKey && this.dashboardGlobalSearchSurfaceLoadingAll[surfaceKey]);
        },
        setDashboardGlobalSearchSurfaceLoadingAll(surfaceKey, loading) {
            if (!surfaceKey) {
                return;
            }

            const next = { ...this.dashboardGlobalSearchSurfaceLoadingAll };

            if (loading) {
                next[surfaceKey] = true;
            } else {
                delete next[surfaceKey];
            }

            this.dashboardGlobalSearchSurfaceLoadingAll = next;
        },
        loadDashboardGlobalSearchSurface(surface = null) {
            if (
                !this.dashboardGlobalSearchSurfaceCanExpand(surface)
                || !this.dashboardGlobalSearchRecordEndpoint
                || this.dashboardGlobalSearchSurfaceIsLoadingAll(surface)
            ) {
                return;
            }

            const query = this.dashboardGlobalSearchQuery.trim();
            const surfaceKey = surface.surface_key;
            const wave = Number.isFinite(Number(surface.wave)) ? Math.max(1, Math.min(3, Number(surface.wave))) : this.dashboardGlobalSearchActiveWave;
            const limit = this.dashboardGlobalSearchSurfaceExpandLimit(surface);

            if (query.length < this.dashboardGlobalSearchMinChars || limit <= this.dashboardGlobalSearchSurfaceShownCount(surface)) {
                return;
            }

            this.setDashboardGlobalSearchSurfaceLoadingAll(surfaceKey, true);

            this.axios.get(this.dashboardGlobalSearchRecordEndpoint, {
                params: {
                    search: query,
                    wave: wave,
                    limit_per_surface: limit,
                    scope: 'current',
                    surface_key: surfaceKey,
                },
            }).then((response) => {
                if (!this.dashboardGlobalSearchOpen || this.dashboardGlobalSearchQuery.trim() !== query) {
                    return;
                }

                const payload = response && response.data ? response.data : {};

                if (payload.success === false) {
                    throw new Error(payload.message || 'Results could not load.');
                }

                this.mergeDashboardGlobalSearchGroups(Array.isArray(payload.groups) ? payload.groups : []);
            }).catch((error) => {
                if (typeof this.openModalWarning === 'function') {
                    this.openModalWarning('ERROR', (error && error.message) ? error.message : 'Results could not load.');
                }
            }).finally(() => {
                this.setDashboardGlobalSearchSurfaceLoadingAll(surfaceKey, false);
            });
        },
        mergeDashboardGlobalSearchGroups(groups) {
            const merged = this.dashboardGlobalSearchGroups.map((group) => ({
                ...group,
                surfaces: Array.isArray(group.surfaces) ? group.surfaces.slice() : [],
            }));
            const groupIndexes = {};

            merged.forEach((group, index) => {
                groupIndexes[group.workspace_group] = index;
            });

            groups.forEach((group) => {
                if (!group || !group.workspace_group || !Array.isArray(group.surfaces) || !group.surfaces.length) {
                    return;
                }

                if (Object.prototype.hasOwnProperty.call(groupIndexes, group.workspace_group)) {
                    const targetGroup = merged[groupIndexes[group.workspace_group]];
                    const surfaceIndexes = {};

                    targetGroup.surfaces.forEach((surface, index) => {
                        surfaceIndexes[surface.surface_key] = index;
                    });

                    group.surfaces.forEach((surface) => {
                        if (!surface || !surface.surface_key) {
                            return;
                        }

                        if (Object.prototype.hasOwnProperty.call(surfaceIndexes, surface.surface_key)) {
                            targetGroup.surfaces[surfaceIndexes[surface.surface_key]] = surface;
                        } else {
                            targetGroup.surfaces.push(surface);
                        }
                    });

                    return;
                }

                groupIndexes[group.workspace_group] = merged.length;
                merged.push({
                    ...group,
                    surfaces: group.surfaces.slice(),
                });
            });

            this.dashboardGlobalSearchGroups = this.prioritizeDashboardGlobalSearchPreferredGroups(merged);
        },
        prioritizeDashboardGlobalSearchPreferredGroups(groups) {
            if (
                this.dashboardGlobalSearchScope === 'current'
                || !Array.isArray(groups)
                || !groups.length
            ) {
                return groups;
            }

            const prioritized = groups.slice();
            const currentSurfaceKey = this.dashboardGlobalSearchCurrentScopeAvailable
                ? this.dashboardGlobalSearchCurrentSurface.surfaceKey
                : '';
            const preparedGroups = admin2026GlobalSearchPrepareGroupsForOrdering(prioritized);
            const currentSurfaceGroup = currentSurfaceKey
                && currentSurfaceKey !== admin2026GlobalSearchClientsSurface
                && admin2026GlobalSearchSurfaceDisplayGroup(currentSurfaceKey, '') !== admin2026GlobalSearchClientsGroup
                && !admin2026GlobalSearchSurfaceBelongsToClients(preparedGroups, currentSurfaceKey)
                ? admin2026GlobalSearchExtractCurrentSurfaceGroup(preparedGroups, currentSurfaceKey)
                : null;
            const refreshedGroups = preparedGroups
                .map((group) => admin2026GlobalSearchRefreshGroup(group, currentSurfaceKey))
                .filter((group) => Array.isArray(group.surfaces) && group.surfaces.length);
            const clientsGroup = admin2026GlobalSearchPullClientsGroupWithClientAccounts(refreshedGroups);
            const currentGroup = !currentSurfaceGroup && currentSurfaceKey
                ? admin2026GlobalSearchPullGroupContainingSurface(refreshedGroups, currentSurfaceKey)
                : null;

            const ordered = [];

            refreshedGroups.sort(admin2026GlobalSearchCompareGroups);

            if (clientsGroup) {
                ordered.push(clientsGroup);
            }

            if (currentSurfaceGroup) {
                ordered.push(admin2026GlobalSearchRefreshGroup(currentSurfaceGroup, currentSurfaceKey));
            } else if (currentGroup) {
                ordered.push(currentGroup);
            }

            return admin2026GlobalSearchStripOrderingKeys(ordered.concat(refreshedGroups));
        },
        resetDashboardGlobalSearchRecords() {
            this.dashboardGlobalSearchGroups = [];
            this.dashboardGlobalSearchSurfaceLoadingAll = {};
            this.dashboardGlobalSearchWaveStatus = {
                1: 'idle',
                2: 'idle',
                3: 'idle',
            };
        },
        abortDashboardGlobalSearchRequest() {
            if (this.dashboardGlobalSearchAbortController && typeof this.dashboardGlobalSearchAbortController.abort === 'function') {
                this.dashboardGlobalSearchAbortController.abort();
            }

            this.dashboardGlobalSearchAbortController = null;
        },
        clearDashboardGlobalSearchDebounce() {
            if (this.dashboardGlobalSearchDebounceId) {
                clearTimeout(this.dashboardGlobalSearchDebounceId);
            }

            this.dashboardGlobalSearchDebounceId = null;
        },
        syncDashboardGlobalSearchUrl(explicitUrl = null) {
            if (!this.dashboardGlobalSearchEnabled || !window.history || typeof window.history.replaceState !== 'function') {
                return;
            }

            let nextUrl = admin2026GlobalSearchBaseUrl(explicitUrl || this.dashboardGlobalSearchDashboardUrl);

            try {
                const parsed = new URL(nextUrl, window.location.origin);
                const params = parsed.searchParams;

                params.delete('drawer');
                params.delete('search');
                params.delete('search_scope');

                if (this.dashboardGlobalSearchOpen) {
                    params.set('drawer', 'search');

                    if (this.dashboardGlobalSearchQuery.trim().length) {
                        params.set('search', this.dashboardGlobalSearchQuery.trim());
                    }

                    if (this.dashboardGlobalSearchCurrentScopeAvailable) {
                        params.set('search_scope', this.normalizeDashboardGlobalSearchScope());
                    }
                }

                const serialized = params.toString();
                nextUrl = parsed.pathname + (serialized ? `?${serialized}` : '') + parsed.hash;
            } catch (error) {
                if (!this.dashboardGlobalSearchOpen) {
                    nextUrl = nextUrl
                        .replace(/[?&](drawer|search|search_scope)=[^&]*?/g, '')
                        .replace(/[?&]$/, '');
                }
            }

            window.history.replaceState({}, '', nextUrl);
        },
        focusDashboardGlobalSearchInput() {
            this.$nextTick(() => {
                const input = this.$refs.dashboardGlobalSearchInput;

                if (input && typeof input.focus === 'function') {
                    input.focus();
                    input.select();
                }
            });
        },
        handleDashboardGlobalSearchShortcut(event) {
            if (
                !this.dashboardGlobalSearchEnabled
                || this.admin2026GlobalSearchOnboardingActive()
                || !event
            ) {
                return;
            }

            if (event.key === 'Escape' && this.dashboardGlobalSearchOpen) {
                event.preventDefault();
                if (typeof event.stopPropagation === 'function') {
                    event.stopPropagation();
                }
                if (typeof event.stopImmediatePropagation === 'function') {
                    event.stopImmediatePropagation();
                }

                this.closeDashboardGlobalSearch(true, 'escape');
                return;
            }

            if (event.defaultPrevented || event.altKey) {
                return;
            }

            const key = typeof event.key === 'string' ? event.key.toLowerCase() : '';
            const isCommandSearchShortcut = key === 'k' && (event.metaKey || event.ctrlKey) && !event.shiftKey;
            const isSlashSearchShortcut = event.key === '/' && !event.metaKey && !event.ctrlKey;

            if (!isCommandSearchShortcut && !isSlashSearchShortcut) {
                return;
            }

            const activeElement = document.activeElement;
            const activeTag = activeElement && activeElement.tagName ? activeElement.tagName.toLowerCase() : '';
            const isSearchInput = activeElement && activeElement === this.$refs.dashboardGlobalSearchInput;
            const isTypingField = activeElement && (
                activeElement.isContentEditable
                || ['input', 'textarea', 'select'].includes(activeTag)
            );

            if (isTypingField && !isSearchInput) {
                return;
            }

            event.preventDefault();
            if (this.dashboardGlobalSearchOpen) {
                this.focusDashboardGlobalSearchInput();
                return;
            }

            this.openDashboardGlobalSearch();
        },
        handleDashboardGlobalSearchPopState() {
            if (!this.dashboardGlobalSearchEnabled) {
                this.dashboardGlobalSearchOpen = false;
                this.resetDashboardGlobalSearchBackdropPointer();
                this.dashboardGlobalSearchQuery = '';
                this.dashboardGlobalSearchRecentSearchDraftQuery = '';
                this.dashboardGlobalSearchScope = this.normalizeDashboardGlobalSearchScope(this.dashboardGlobalSearchDefaultScope);
                this.dashboardGlobalSearchIgnoreDialogCloseUntil = 0;
                this.resetDashboardGlobalSearchRecords();

                return;
            }

            const state = this.readDashboardGlobalSearchLocation();

            if (
                state.open
                && typeof this.admin2026RunAfterScreenOnboarding === 'function'
                && this.admin2026RunAfterScreenOnboarding(() => {
                    this.handleDashboardGlobalSearchPopState();
                })
            ) {
                this.dashboardGlobalSearchOpen = false;
                this.resetDashboardGlobalSearchBackdropPointer();
                this.dashboardGlobalSearchRecentSearchDraftQuery = '';

                return;
            }

            if (this.admin2026GlobalSearchOnboardingActive()) {
                this.dashboardGlobalSearchOpen = false;
                this.resetDashboardGlobalSearchBackdropPointer();
                this.dashboardGlobalSearchQuery = '';
                this.dashboardGlobalSearchRecentSearchDraftQuery = '';
                this.dashboardGlobalSearchScope = this.normalizeDashboardGlobalSearchScope(this.dashboardGlobalSearchDefaultScope);
                this.dashboardGlobalSearchIgnoreDialogCloseUntil = 0;
                this.resetDashboardGlobalSearchRecords();

                return;
            }

            this.clearDashboardGlobalSearchDebounce();
            this.abortDashboardGlobalSearchRequest();

            if (!state.open) {
                this.dashboardGlobalSearchOpen = false;
                this.resetDashboardGlobalSearchBackdropPointer();
                this.dashboardGlobalSearchQuery = '';
                this.dashboardGlobalSearchRecentSearchDraftQuery = '';
                this.dashboardGlobalSearchScope = this.normalizeDashboardGlobalSearchScope(this.dashboardGlobalSearchDefaultScope);
                this.dashboardGlobalSearchIgnoreDialogCloseUntil = 0;
                this.resetDashboardGlobalSearchRecords();

                return;
            }

            this.armDashboardGlobalSearchDialogCloseIgnoreWindow();
            this.dashboardGlobalSearchOpen = true;
            this.dashboardGlobalSearchQuery = state.query;
            this.dashboardGlobalSearchRecentSearchDraftQuery = '';
            this.dashboardGlobalSearchScope = this.normalizeDashboardGlobalSearchScope(state.scope);
            this.resetDashboardGlobalSearchRecords();
            this.focusDashboardGlobalSearchInput();

            if (state.query.trim().length >= this.dashboardGlobalSearchMinChars) {
                this.startDashboardGlobalSearchFromWave(this.dashboardGlobalSearchActiveWave, true);
            }
        },
        readDashboardGlobalSearchLocation() {
            const params = new URLSearchParams(window.location.search || '');
            const open = params.get('drawer') === 'search';

            return {
                open: open,
                query: open ? (params.get('search') || '') : '',
                scope: open ? this.normalizeDashboardGlobalSearchScope(params.get('search_scope')) : this.dashboardGlobalSearchDefaultScope,
            };
        },
        prepareDashboardGlobalSearchNavigation(event) {
            if (
                !event
                || event.defaultPrevented
                || event.button !== 0
                || event.metaKey
                || event.ctrlKey
                || event.shiftKey
                || event.altKey
            ) {
                return;
            }

            this.clearDashboardGlobalSearchDebounce();
            this.abortDashboardGlobalSearchRequest();
            this.syncDashboardGlobalSearchUrl(this.dashboardGlobalSearchDashboardUrl);
        },
        isDashboardGlobalSearchCancellation(error) {
            return !!(
                error
                && (
                    error.code === 'ERR_CANCELED'
                    || error.name === 'CanceledError'
                    || error.name === 'AbortError'
                )
            );
        },
    },
    mounted() {
        this.dashboardGlobalSearchScope = this.normalizeDashboardGlobalSearchScope(
            this.dashboardGlobalSearchOpen ? this.dashboardGlobalSearchScope : this.dashboardGlobalSearchDefaultScope
        );
        this.recordDashboardGlobalSearchCurrentScreen();
        this.loadDashboardGlobalSearchRecentSearches();

        document.addEventListener('keydown', this.handleDashboardGlobalSearchShortcut, true);
        window.addEventListener('popstate', this.handleDashboardGlobalSearchPopState);

        const initialLocationState = this.readDashboardGlobalSearchLocation();

        if (
            initialLocationState.open
            && typeof this.admin2026RunAfterScreenOnboarding === 'function'
            && this.admin2026RunAfterScreenOnboarding(() => {
                this.handleDashboardGlobalSearchPopState();
            })
        ) {
            return;
        }

        if (this.dashboardGlobalSearchOpen && !this.admin2026GlobalSearchOnboardingActive()) {
            this.armDashboardGlobalSearchDialogCloseIgnoreWindow();
            this.focusDashboardGlobalSearchInput();

            if (this.dashboardGlobalSearchQuery.trim().length >= this.dashboardGlobalSearchMinChars) {
                this.startDashboardGlobalSearchFromWave(this.dashboardGlobalSearchActiveWave, true);
            }
        }
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleDashboardGlobalSearchShortcut, true);
        window.removeEventListener('popstate', this.handleDashboardGlobalSearchPopState);
        this.clearDashboardGlobalSearchDebounce();
        this.abortDashboardGlobalSearchRequest();
        this.resetDashboardGlobalSearchBackdropPointer();
    },
};
